/* eslint-disable */
import React, { useEffect, useMemo, useState } from 'react'
import { toast } from 'utils/notify'
import Autocomplete from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import {
  Grid,
  Button,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  makeStyles,
  CircularProgress,
  MenuItem,
  Divider,
  Chip,
  Checkbox,
  Link
} from '@material-ui/core'
import ViewHeader from 'components/ViewHeader'
import InputAdornment from '@material-ui/core/InputAdornment'
import { useDispatch, useSelector } from 'react-redux'
import ProgressButton from 'components/ProgressButton'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { Formik, Form } from 'formik'
import { useConfirm } from 'material-ui-confirm'
import { getConfSubEvents } from 'store/session'
import buildingSlice, { fetchBuildings } from 'store/building'
import { getConferenceSponsors } from 'store/sponsor'
import { getModeratorsAndPresenters } from 'store/speaker'
import {
  addTalk,
  checkNumberExistsInTalks,
  fetchTalkById,
  getLastNumber,
  resetTalkStore,
  updateTalkById,
  fetchEventOrSessionTalks
} from 'store/talk'
import { getConfEvents } from 'store/event'
import CustomBox from 'components/Form/CustomBox'
import CustomDateTimePicker from 'components/CustomDateTimePicker'
import { talkFormSchema } from 'schemas/talk'
import { resetSessionStore } from 'store/session'
import { resetEventStore } from 'store/event'
import { getDefaultTimezone } from 'utils/times'
import moment from 'moment-timezone'
import { dateTimeInTimezone, removeUndefinedItemsFromArrayOfString } from 'utils'
import { alreadyUsedPoll, pollAttachOrDetach } from 'store/polling'
import { AssociatedPollMsg, SpeakerRoles } from 'constants/index'
import { Add } from '@material-ui/icons'
import { isDateTimeInRange } from 'utils/talk'
import BuildingForm from 'views/admin/building/BuildingForm'
import CustomPopup from 'components/CustomPopup'
import { colors, getContrastColor } from 'utils/colors'
import OrganizationForm from 'views/admin/organizations/OrganizationForm'
import SpeakerForm from 'views/admin/speakers/SpeakerForm'
import PollAssignment from 'components/PollAssignment/PollAssignment'
import DocumentUpload from 'components/DocumentUpload'
import { FirestoreDatabase, storageRef } from '../../../../index'
import TipTapEditor from 'components/TipTapEditor/TipTapEditor'

import SingleAutocomplete from 'components/SingleAutocomplete'
import MultiAutocomplete from 'components/MultiAutocomplete'
import { TagForm } from 'views/admin/conference/components/TagsManagementForm'
import DataLoading from 'components/DataLoading'
import { summarizeContent, SummarizationContentType } from 'utils/groq'
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined'
import RestartAltOutlinedIcon from '@mui/icons-material/RestartAltOutlined'
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined'
import ConfirmModal from 'components/ConfirmationModal'

const TalkForm = () => {
  const classes = useStyles()
  const { eventId, sessionId, talkId } = useParams()
  const dispatch = useDispatch()
  const confirm = useConfirm()
  const history = useHistory()
  const location = useLocation()

  const previousEventId = location?.state?.eventId || ''
  const previousSessionId = location?.state?.sessionId || ''
  const previousVenueId = location?.state?.venueId || ''
  const previousInheritVenue = location?.state?.inheritVenue || ''
  const previousInheritTime = location?.state?.inheritTime || ''
  const isPosterParam = new URLSearchParams(history.location.search).get('type') === 'poster'

  const [speakerError, setSpeakerError] = useState('')
  const [saveProgress, setSaveProgress] = useState(false)
  const [createNewProgress, setCreateNewProgress] = useState(false)
  const [loading, setLoading] = useState(false)
  const [openVenueModal, setOpenVenueModal] = useState(false)
  const [selectionType, setSelectionType] = useState('') // 'event' or 'session'

  // Attachment states
  const [attachments, setAttachments] = useState([])
  const [loadingAttachments, setLoadingAttachments] = useState(false)
  const [temporaryAttachments, setTemporaryAttachments] = useState([])
  const [attachmentsResetKey, setAttachmentsResetKey] = useState(0)
  const [hasPendingUploads, setHasPendingUploads] = useState(false)

  const [confEvents, setConfEvents] = useState([])
  const [confSubEvents, setConfSubEvents] = useState([])
  const [confSpeakers, setConfSpeakers] = useState([])
  const [confModerators, setConfModerators] = useState([])
  const [confSponsors, setConfSponsors] = useState([])
  const [tagModalOpen, setTagModalOpen] = useState(false)
  const [selectedEventId, setSelectedEventId] = useState('')
  const [selectedSubEventId, setSelectedSubEventId] = useState('')
  const [speakerModalInfo, setSpeakerModalInfo] = useState(null)
  const [openSponsorModal, setOpenSponsorModal] = useState(false)
  const [summarizing, setSummarizing] = useState(false)
  const [reverting, setReverting] = useState(false)
  const [viewingOriginalSynopsis, setViewingOriginalSynopsis] = useState(false)
  const [confirmResummarize, setConfirmResummarize] = useState(false)

  const { talk, lastPosterNumber, lastAbstractNumber } = useSelector((state) => state.talk)
  const { user } = useSelector((state) => state.auth)
  const { buildings } = useSelector((state) => state.building)
  const { conference } = useSelector((state) => state.conference)

  const posterPrefix = conference?.posterPrefix
  const abstractPrefix = conference?.abstractPrefix

  const defaultTimezone = useMemo(() => getDefaultTimezone(conference?.timezone), [conference])

  let lastAbstractNumberSelected = localStorage.getItem('lastAbstractNumberSelected')
  if (!lastAbstractNumberSelected || lastAbstractNumberSelected === 'false') {
    lastAbstractNumberSelected = false
  }

  const startDateLS = localStorage.getItem('talkStartDate')
    ? parseInt(localStorage.getItem('talkStartDate'))
    : null
  const endDateLS = localStorage.getItem('talkEndDate')
    ? parseInt(localStorage.getItem('talkEndDate'))
    : null

  const eventInfo = useMemo(() => {
    const event_id = selectedEventId || talk?.eventId || eventId
    return confEvents?.find((event) => event?.id === event_id)
  }, [selectedEventId, confEvents, talkId, talk, eventId])

  const subEventInfo = useMemo(() => {
    const id = selectedSubEventId || talk?.sessionId || sessionId
    return confSubEvents?.find((event) => event?.id === id)
  }, [selectedSubEventId, confSubEvents, talkId, talk, sessionId])

  const isPoster = useMemo(() => {
    return talk?.isPoster || isPosterParam
  }, [talk, isPosterParam])

  // Combine events and sub-events with dividers for dropdown
  const format = conference?.is24hrFormat ? 'MM/DD HH:mm' : 'MM/DD hh:mm A'
  const combinedEventOptions = useMemo(() => {
    const events = confEvents.map((event) => ({
      ...event,
      title: `${event.title} (${moment(event.startDate).format(format)} - ${moment(
        event.endDate
      ).format(format)}) `,
      type: 'event',
      groupHeader: 'Events'
    }))

    const subEvents = confSubEvents.map((subEvent) => ({
      ...subEvent,
      title: `${subEvent.title} (${moment(subEvent.startDate).format(format)} - ${moment(
        subEvent.endDate
      ).format(format)}) `,
      type: 'session',
      groupHeader: 'Sub Events'
    }))

    return [
      { id: 'events-header', title: 'Events', disabled: true, isDivider: true },
      ...(events.length === 0
        ? [{ id: 'no-events-found', title: 'No event found', isInformation: true }]
        : events),
      { id: 'subevents-header', title: 'Sub Events', disabled: true, isDivider: true },
      ...(subEvents.length === 0
        ? [{ id: 'no-sub-event-found', title: 'No sub-event found', isInformation: true }]
        : subEvents)
    ]
  }, [confEvents, confSubEvents])

  const initialValues = {
    eventId: previousEventId || eventId || talk?.eventId || '',
    sessionId: previousSessionId || sessionId || talk?.sessionId || '',
    venueId: previousVenueId || talk?.venueId || '',
    title: talk?.title || '',
    startDate: startDateLS ? moment(startDateLS).tz(defaultTimezone) : moment().tz(defaultTimezone),
    endDate: endDateLS ? moment(endDateLS).tz(defaultTimezone) : moment().tz(defaultTimezone),
    inheritVenue: previousInheritVenue || talk?.inheritVenue || false,
    inheritTime: previousInheritTime || talk?.inheritTime || false,
    moderators: talk?.moderators || [],
    speakers: talk?.speakers || [],
    sponsors: talk?.sponsors || [],
    tags: talk?.tags || [],
    synopsis: talk?.synopsis || '',
    originalSynopsis: talk?.originalSynopsis || '',
    isAbstract: talkId ? talk?.isAbstract : lastAbstractNumberSelected,
    abstractNumber: !talk?.id && lastAbstractNumber ? lastAbstractNumber + 1 : 1,
    posterNumber: !talk?.id && lastPosterNumber ? lastPosterNumber + 1 : 1,
    havePolls: talk?.havePolls === true ? 'yes' : 'no',
    pollIds: talk?.pollIds ?? (talk?.pollId ? [talk.pollId] : [])
  }

  if (talkId && talk?.id === talkId) {
    initialValues.abstractNumber = talk?.abstractNumber
      ? talk?.abstractNumber
      : lastAbstractNumber
      ? lastAbstractNumber + 1
      : 1
    initialValues.posterNumber = talk?.posterNumber
      ? talk?.posterNumber
      : lastPosterNumber
      ? lastPosterNumber + 1
      : 1
    initialValues.startDate = dateTimeInTimezone(talk.startDate, defaultTimezone)
    initialValues.endDate = dateTimeInTimezone(talk.endDate, defaultTimezone)
  } else {
    if (subEventInfo?.id && selectedSubEventId) {
      if (
        !moment(initialValues.startDate).isBetween(subEventInfo.startDate, subEventInfo.endDate)
      ) {
        initialValues.startDate = dateTimeInTimezone(subEventInfo.startDate, defaultTimezone)
        initialValues.endDate = dateTimeInTimezone(subEventInfo.endDate, defaultTimezone)
      }
    } else if (eventInfo?.id && selectedEventId) {
      if (!moment(initialValues.startDate).isBetween(eventInfo?.startDate, eventInfo?.endDate)) {
        initialValues.startDate = dateTimeInTimezone(eventInfo?.startDate, defaultTimezone)
        initialValues.endDate = dateTimeInTimezone(eventInfo?.endDate, defaultTimezone)
      }
    }
  }

  const handleEventChange = (event, setFieldValue, values) => {
    const selectedId = event.target.value
    if (!selectedId) {
      setFieldValue('eventId', '')
      setFieldValue('sessionId', '')
      setSelectedEventId('')
      setSelectionType('')
      return
    }

    // Find the selected item in the combined list
    const selectedItem = combinedEventOptions.find((item) => item.id === selectedId)
    if (!selectedItem?.id) return

    // Determine if it's an event or a sub-event (session)
    if (selectedItem.type === 'event') {
      setFieldValue('eventId', selectedId)
      setSelectedEventId(selectedId)
      setFieldValue('sessionId', '')
      setSelectedSubEventId('')
      setSelectionType('event')

      // If inherit venue is checked, set the venue from the selected event
      if (values.inheritVenue && selectedItem.venueId) {
        setFieldValue('venueId', selectedItem.venueId)
      }

      // If inherit time is checked, set the times from the selected event
      if (values.inheritTime) {
        if (selectedItem.startDate) {
          setFieldValue('startDate', moment(selectedItem.startDate).tz(defaultTimezone))
        }
        if (selectedItem.endDate) {
          setFieldValue('endDate', moment(selectedItem.endDate).tz(defaultTimezone))
        }
      }
    } else if (selectedItem.type === 'session') {
      // It's a sub-event (session)
      setFieldValue('sessionId', selectedId)
      setSelectedSubEventId(selectedId)
      setFieldValue('eventId', '')
      setSelectedEventId('')
      setSelectionType('session')

      // If inherit venue is checked, set the venue from the selected sub-event
      if (values.inheritVenue && selectedItem.venueId) {
        setFieldValue('venueId', selectedItem.venueId)
      }

      // If inherit time is checked, set the times from the selected sub-event
      if (values.inheritTime) {
        if (selectedItem.startDate) {
          setFieldValue('startDate', moment(selectedItem.startDate).tz(defaultTimezone))
        }
        if (selectedItem.endDate) {
          setFieldValue('endDate', moment(selectedItem.endDate).tz(defaultTimezone))
        }
      }
    }
  }

  const handleInheritTimeChange = (e, setFieldValue, values) => {
    const isChecked = e.target.checked
    setFieldValue('inheritTime', isChecked)

    if (isChecked) {
      let selectedItem = null

      // Check if a session (sub-event) is selected
      if ((selectionType === 'session' || sessionId) && values.sessionId) {
        selectedItem = confSubEvents.find((subEvent) => subEvent.id === values.sessionId)
      } else if ((selectionType === 'event' || eventId) && values.eventId) {
        selectedItem = confEvents.find((event) => event.id === values.eventId)
      }

      if (selectedItem) {
        if (selectedItem.startDate) {
          setFieldValue('startDate', moment(selectedItem.startDate).tz(defaultTimezone))
        }
        if (selectedItem.endDate) {
          setFieldValue('endDate', moment(selectedItem.endDate).tz(defaultTimezone))
        }
      }
    }
  }

  const handleInheritVenueChange = (e, setFieldValue, values) => {
    const isChecked = e.target.checked
    setFieldValue('inheritVenue', isChecked)

    if (isChecked) {
      let selectedItem = null

      // Check if a session (sub-event) is selected
      if ((selectionType === 'session' || sessionId) && values?.sessionId) {
        selectedItem = confSubEvents.find((subEvent) => subEvent.id === values.sessionId)
      } else if ((selectionType === 'event' || eventId) && values?.eventId) {
        selectedItem = confEvents.find((event) => event.id === values.eventId)
      }

      if (selectedItem?.venueId) {
        setFieldValue('venueId', selectedItem.venueId)
      }
    }
  }

  const fetchModeratorsAndPresenters = async () => {
    const data = await getModeratorsAndPresenters(user?.conferenceId)
    setConfSpeakers(data.presenters)
    setConfModerators(data.moderators)
  }

  const fetchSponsors = async () => {
    const sponsors = await getConferenceSponsors(user?.conferenceId)
    setConfSponsors(sponsors)
  }

  // Fetch talk attachments
  const fetchTalkAttachments = async () => {
    if (!talkId) return

    try {
      setLoadingAttachments(true)

      // Get reference to the talk document
      const talkRef = FirestoreDatabase.collection('talks').doc(talkId)

      // Get attachments collection for this talk
      const attachmentsSnapshot = await talkRef.collection('attachments').get()

      // Map snapshot to attachments array
      const fetchedAttachments = attachmentsSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }))

      setAttachments(fetchedAttachments)
    } catch (error) {
      console.error('Error fetching talk attachments:', error)
      toast.error('Could not load attachments.')
    } finally {
      setLoadingAttachments(false)
    }
  }

  // Handle attachment added
  const handleAttachmentAdded = async (newAttachments) => {
    if (!talkId) {
      // For new talks, store attachments temporarily
      handleTemporaryAttachments(newAttachments)
      return
    }

    try {
      setLoadingAttachments(true)

      // Get reference to the talk document
      const talkRef = FirestoreDatabase.collection('talks').doc(talkId)
      const batch = FirestoreDatabase.batch()

      // Process each new attachment (already uploaded to storage by DocumentUpload)
      for (const attachment of newAttachments) {
        const { file, ...attachmentData } = attachment
        const newAttachmentRef = talkRef.collection('attachments').doc()
        batch.set(newAttachmentRef, attachmentData)
      }

      await batch.commit()

      // Refresh attachments
      fetchTalkAttachments()
      toast.success('Attachments uploaded.')
    } catch (error) {
      console.error('Error adding attachments:', error)
      toast.error('Could not upload attachments.')
    } finally {
      setLoadingAttachments(false)
    }
  }

  // Handle attachment deleted
  const handleAttachmentDeleted = async (attachment) => {
    if (!talkId) {
      // For new talks, remove from temporary attachments
      setTemporaryAttachments((prev) => prev.filter((item) => item.path !== attachment.path))
      return
    }

    try {
      setLoadingAttachments(true)

      // Delete the file from storage if it exists
      if (attachment.path) {
        const fileRef = storageRef.child(attachment.path)
        await fileRef.delete().catch((err) => {
          console.log('Storage file may not exist:', err)
        })
      }

      // Delete the attachment document
      await FirestoreDatabase.collection('talks')
        .doc(talkId)
        .collection('attachments')
        .doc(attachment.id)
        .delete()

      // Update state to remove the deleted attachment
      setAttachments((prev) => prev.filter((item) => item.id !== attachment.id))
      // toast.success('Attachment deleted successfully')
    } catch (error) {
      console.error('Error deleting attachment:', error)
      toast.error('Could not delete attachment.')
    } finally {
      setLoadingAttachments(false)
    }
  }

  // Handle temporary attachments for new talks
  const handleTemporaryAttachments = (attachmentsList) => {
    setTemporaryAttachments((prev) => [...prev, ...attachmentsList])
  }

  useEffect(() => {
    const fetch = async () => {
      await dispatch(getLastNumber(isPoster ? 'posterNumber' : 'abstractNumber'))
    }
    fetch()
  }, [isPoster])

  useEffect(() => {
    const unsubBuildings = fetchBuildings(user?.conferenceId, (buildingsData) => {
      dispatch(buildingSlice.actions.setBuildings(buildingsData))
    })
    const fetchData = async () => {
      setLoading(true)
      const events = await getConfEvents(user?.conferenceId)
      const subEvents = await getConfSubEvents(user?.conferenceId)
      // Filter events that don't have sub-events
      setConfEvents(events.filter((event) => !event.hasSubEvents))
      setConfSubEvents(subEvents)

      // Set the selection type based on what we have in the talk data
      if (talkId && talk?.id) {
        if (talk.sessionId) {
          setSelectionType('session')
        } else if (talk.eventId) {
          setSelectionType('event')
        }
      }

      await fetchModeratorsAndPresenters()
      await fetchSponsors()
      // if (eventId) {
      //   await dispatch(fetchEventById(eventId))
      // }
      if (talkId) {
        await dispatch(fetchTalkById(talkId))
        await fetchTalkAttachments() // Fetch attachments when editing a talk
      }
      // if (sessionId) {
      //   await dispatch(fetchSessionById(sessionId))
      // }
      setLoading(false)
    }
    fetchData()
    return () => {
      unsubBuildings && unsubBuildings()
      dispatch(resetTalkStore())
      dispatch(resetSessionStore())
      dispatch(resetEventStore())
    }
  }, [user?.conferenceId])

  // Fetch talk attachments when component loads with a talk ID
  useEffect(() => {
    if (talkId) {
      fetchTalkAttachments()
    }
  }, [talkId])

  const goBack = () => {
    dispatch(resetTalkStore())
    dispatch(resetSessionStore())
    dispatch(resetEventStore())
    history.goBack()
  }

  const persistSynopsis = async (synopsis, originalSynopsis) => {
    await dispatch(updateTalkById(talkId, { synopsis, originalSynopsis }))
  }

  const handleSummarizeSynopsis = async (values, setFieldValue) => {
    setConfirmResummarize(false)
    setSummarizing(true)
    try {
      const originalSynopsis = values.originalSynopsis || values.synopsis
      const summary = await summarizeContent(
        originalSynopsis,
        SummarizationContentType.SESSION_SYNOPSIS
      )
      if (summary) {
        setFieldValue('originalSynopsis', originalSynopsis)
        setFieldValue('synopsis', summary)
        if (talkId) {
          await persistSynopsis(summary, originalSynopsis)
          toast.success('Synopsis summarized and saved.')
        } else {
          toast.success('Synopsis summarized.')
        }
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Failed to summarize synopsis.')
    } finally {
      setSummarizing(false)
    }
  }

  const handleRevertSynopsisToOriginal = async (values, setFieldValue) => {
    setReverting(true)
    try {
      setFieldValue('synopsis', values.originalSynopsis)
      setFieldValue('originalSynopsis', '')
      setViewingOriginalSynopsis(false)
      if (talkId) {
        await persistSynopsis(values.originalSynopsis, '')
        toast.success('Synopsis reverted to original and saved.')
      } else {
        toast.success('Synopsis reverted to original.')
      }
    } finally {
      setReverting(false)
    }
  }

  const onSubmit = async (values, { setFieldError }) => {
    try {
      setSaveProgress(true)

      const {
        eventId,
        sessionId,
        title,
        venueId,
        startDate,
        endDate,
        sponsors,
        speakers,
        moderators,
        tags,
        inheritVenue,
        inheritTime,
        havePolls,
        pollIds,
        isAbstract = false,
        abstractNumber,
        posterNumber,
        synopsis,
        originalSynopsis
      } = values
      const sDate = typeof startDate === 'number' ? startDate : startDate.valueOf()
      const eDate =
        typeof endDate === 'number' ? endDate : endDate.seconds(0).milliseconds(0).valueOf()

      console.log('selected start date', sDate)
      const compStartDate = values.sessionId ? subEventInfo?.startDate : eventInfo?.startDate
      const compEndDate = values.sessionId ? subEventInfo?.endDate : eventInfo?.endDate
      const compType = values.sessionId ? 'sub event' : 'event'
      console.log('comparison start date', compStartDate)

      let hasError = false
      if (!values.eventId && !values.sessionId) {
        setFieldError('eventId', 'Please select an event or sub-event')
        hasError = true
      }
      if (sDate < compStartDate) {
        setFieldError('startDate', `Start time can not be before ${compType} start time`)
        hasError = true
      }

      if (sDate > compEndDate) {
        setFieldError('startDate', `Start time can not be after ${compType} end time`)
        hasError = true
      }

      if (eDate < compStartDate) {
        setFieldError('endDate', `End time can not be before ${compType} start time`)
        hasError = true
      }

      if (eDate > compEndDate) {
        setFieldError('endDate', `End time can not be after ${compType} end time`)
        hasError = true
      }

      if (havePolls === 'yes' && !speakers.length) {
        setSpeakerError('Please select at least one speaker.')
        hasError = true
      }

      if (havePolls === 'yes' && !pollIds?.length) {
        setFieldError('pollIds', 'Select at least one poll')
        hasError = true
      }
      if (hasError) {
        toast.warning('Fill in all required fields before saving.')
        return
      }

      const payload = {
        title: title.trim(),
        venueId: venueId,
        startDate: moment(sDate).utc().valueOf(),
        endDate: moment(eDate).utc().valueOf(),
        moderators: removeUndefinedItemsFromArrayOfString(moderators),
        speakers: removeUndefinedItemsFromArrayOfString(speakers),
        sponsors: removeUndefinedItemsFromArrayOfString(sponsors),
        tags: removeUndefinedItemsFromArrayOfString(tags),
        inheritVenue,
        inheritTime,

        havePolls: havePolls === 'yes',
        pollIds: havePolls === 'yes' ? pollIds : [],
        // Legacy mirror for the mobile app's talk-detail screen, which still builds its poll
        // join link from `talk.pollId` and can't be redeployed on short notice. Which poll
        // ends up here doesn't matter — PoolForm.js resolves a bare pollId back to its owning
        // talk and then discovers that talk's *entire* pollIds set from there, so any valid
        // one is enough to get the attendee into the room. Remove once the mobile app sends
        // `talkId` directly instead (see docs/multi-poll-assignment.md).
        pollId: havePolls === 'yes' && pollIds.length ? pollIds[pollIds.length - 1] : null,
        eventId: eventId || '',
        sessionId: sessionId || '',
        isAbstract,
        synopsis: synopsis.trim(),
        originalSynopsis: originalSynopsis ?? '',
        isPoster: isPoster,
        conferenceId: user?.conferenceId
      }

      if (!hasError && !payload.isAbstract) {
        const existingTalks = await fetchEventOrSessionTalks(eventId, sessionId)
        const filteredTalks = talkId
          ? existingTalks.filter((talk) => talk.id !== talkId)
          : existingTalks
        if (existingTalks?.length) {
          const res = isDateTimeInRange(
            payload?.startDate,
            payload?.endDate,
            payload.venueId,
            filteredTalks
          )
          if (res) {
            toast.warning(
              `${isPoster ? 'Poster' : 'Talk'} start time overlaps with another talk/poster.`
            )
            return
          }
        }
      }

      let numberAlreadyExists = null,
        confirmTitle,
        res = null,
        message
      if (isAbstract) {
        const abs_Number = parseInt(abstractNumber)
        const pos_number = parseInt(posterNumber)
        payload[isPoster ? 'posterNumber' : 'abstractNumber'] = isPoster ? pos_number : abs_Number
        const keyToCheck = isPoster ? 'posterNumber' : 'abstractNumber'
        numberAlreadyExists = await dispatch(
          checkNumberExistsInTalks(keyToCheck, isPoster ? pos_number : abs_Number, talkId)
        )
        confirmTitle = `This ${
          isPoster ? 'Poster' : 'Abstract'
        } Number already exists for some other poster or talk.`

        if (numberAlreadyExists) {
          try {
            setSaveProgress(false)
            await confirm({
              title: confirmTitle,
              description: 'Do you still wish to continue ?'
            })
          } catch {
            return false
          }
        }
      } else {
        payload['abstractNumber'] = null
        payload['posterNumber'] = null
      }

      const previousPollIds = talk?.pollIds ?? (talk?.pollId ? [talk.pollId] : [])
      const addedPollIds = payload.pollIds.filter((id) => !previousPollIds.includes(id))
      const removedPollIds = previousPollIds.filter((id) => !payload.pollIds.includes(id))

      for (const id of addedPollIds) {
        const isAlreadyUsed = await alreadyUsedPoll(id)
        if (isAlreadyUsed) {
          toast.warning(AssociatedPollMsg)
          setSaveProgress(false)
          return
        }
      }

      setSaveProgress(true)
      let newTalkId
      if (talkId) {
        res = await dispatch(updateTalkById(talkId, payload))
        message = `${isPoster ? 'Poster Talk' : 'Talk'} updated successfully`
      } else {
        newTalkId = await dispatch(addTalk(payload))
        message = `${isPoster ? 'Poster Talk' : 'Talk'} created successfully`

        // Upload any temporary attachments for new talks
        if (temporaryAttachments.length > 0 && newTalkId) {
          const batch = FirestoreDatabase.batch()
          const talkRef = FirestoreDatabase.collection('talks').doc(newTalkId)

          for (const attachment of temporaryAttachments) {
            try {
              // Upload file to Firebase Storage
              const fileRef = storageRef.child(attachment.path)
              await fileRef.put(attachment.file)
              const downloadUrl = await fileRef.getDownloadURL()

              // Create attachment record without the file object
              const { file, ...attachmentData } = attachment
              const newAttachmentRef = talkRef.collection('attachments').doc()
              batch.set(newAttachmentRef, {
                ...attachmentData,
                downloadUrl
              })
            } catch (error) {
              console.error(`Error uploading file ${attachment.fileName}:`, error)
              toast.error(`Failed to upload ${attachment.fileName}`)
            }
          }

          await batch.commit()
        }
      }

      // detach polls that were removed, and attach newly assigned polls to this talk
      await Promise.all(
        removedPollIds.map((id) =>
          pollAttachOrDetach(id, { eventId: null, sessionId: null, talkId: null, alreadyUsed: false })
        )
      )
      await Promise.all(
        addedPollIds.map((id) =>
          pollAttachOrDetach(id, {
            eventId: eventInfo?.id ?? null,
            sessionId: subEventInfo?.id ?? null,
            talkId: talkId ? talkId : newTalkId,
            alreadyUsed: true
          })
        )
      )

      if (res || newTalkId) {
        if (values.inheritTime) {
          localStorage.setItem('talkStartDate', payload.startDate)
          localStorage.setItem('talkEndDate', payload.endDate)
        } else {
          localStorage.setItem('talkStartDate', payload.endDate)
          localStorage.setItem(
            'talkEndDate',
            payload.endDate + (payload.endDate - payload.startDate)
          )
        }
        localStorage.setItem('lastAbstractNumberSelected', isAbstract)
        toast.success(message)
        return true
      }
    } catch (error) {
      console.error(error)
      toast.error(error?.message)
    }
  }

  if (loading) {
    return (
      <Box sx={{ mt: '2rem' }}>
        <DataLoading />
      </Box>
    )
  }

  return (
    <Box>
      <CustomBox>
        <Formik initialValues={initialValues} onSubmit={onSubmit} validationSchema={talkFormSchema}>
          {({
            values,
            setFieldValue,
            isValid,
            errors,
            touched,
            setFieldTouched,
            validateForm,
            submitForm,
            resetForm
          }) => {
            const overlappingIds = (values.moderators || []).filter((id) =>
              (values.speakers || []).includes(id)
            )
            const overlappingNames = overlappingIds
              .map((id) => {
                const person = [...confModerators, ...confSpeakers].find((p) => p.id === id)
                return person?.fullName || id
              })
              .join(', ')
            const rolesOverlapWarning = overlappingNames
              ? `${overlappingNames} ${
                  overlappingIds.length > 1 ? 'are' : 'is'
                } added as both a moderator and a speaker.`
              : ''

            return (
            <Form>
              <ViewHeader
                title={
                  isPoster
                    ? talkId
                      ? 'Edit Poster'
                      : 'Create Poster'
                    : talkId
                    ? 'Edit Talk'
                    : 'Create Talk'
                }>
                <Box style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                  <Button variant="outlined" onClick={goBack}>
                    Back
                  </Button>
                  <ProgressButton
                    type="button"
                    label="Save"
                    inProgress={saveProgress}
                    disabled={saveProgress || createNewProgress}
                    onClick={async () => {
                      let proceed = false
                      if (hasPendingUploads) {
                        try {
                          await confirm({
                            title: 'Pending File Uploads',
                            description:
                              "You have selected files that haven't been uploaded. If you save now without clicking 'Upload All,' these files will not be uploaded. Do you want to continue?"
                          })
                          proceed = true
                        } catch {
                          proceed = false
                        }
                      } else {
                        proceed = true
                      }
                      if (proceed || !hasPendingUploads) {
                        setSaveProgress(true)
                        await validateForm()
                        const submitStatus = await submitForm()
                        setSaveProgress(false)
                        if (isValid && submitStatus) {
                          goBack()
                        }
                      }
                    }}
                  />
                  <ProgressButton
                    type="button"
                    label="Save and Create New"
                    inProgress={createNewProgress}
                    disabled={createNewProgress || saveProgress}
                    onClick={async () => {
                      let proceed = false
                      if (hasPendingUploads) {
                        try {
                          await confirm({
                            title: 'Pending File Uploads',
                            description:
                              "You have selected files that haven't been uploaded. If you save now without clicking 'Upload All,' these files will not be uploaded. Do you want to continue?"
                          })
                          proceed = true
                        } catch {
                          proceed = false
                        }
                      } else {
                        proceed = true
                      }
                      if (proceed || !hasPendingUploads) {
                        setCreateNewProgress(true)
                        await validateForm()
                        const submitStatus = await submitForm()
                        setCreateNewProgress(false)
                        setSaveProgress(false)
                        if (submitStatus && isValid) {
                          setAttachments([])
                          setTemporaryAttachments([])
                          setAttachmentsResetKey((prev) => prev + 1)
                          dispatch(resetTalkStore())
                          const isAbstractTalk = localStorage.getItem('lastAbstractNumberSelected')
                          const keyToCheck = isPoster ? 'posterNumber' : 'abstractNumber'
                          let nextNumber = 1
                          if (isAbstractTalk === 'true') {
                            const lastNumber = await dispatch(getLastNumber(keyToCheck))
                            nextNumber = lastNumber + 1
                          }
                          resetForm({
                            values: {
                              ...initialValues,
                              eventId: values.eventId || '',
                              sessionId: values.sessionId || '',
                              venueId: values.venueId || '',
                              inheritVenue: values.inheritVenue || false,
                              inheritTime: values.inheritTime || false,
                              startDate: moment(parseInt(localStorage.getItem('talkStartDate'))).tz(
                                conference ? conference?.timezone : defaultTimezone
                              ),
                              endDate: moment(parseInt(localStorage.getItem('talkEndDate'))).tz(
                                conference ? conference?.timezone : defaultTimezone
                              ),
                              isAbstract: isAbstractTalk === 'true',
                              [keyToCheck]: isAbstractTalk === 'true' ? nextNumber : 1,
                              title: '',
                              speakers: [],
                              moderators: [],
                              sponsors: [],
                              tags: [],
                              synopsis: '',
                              originalSynopsis: '',
                              havePolls: 'no',
                              pollIds: []
                            }
                          })
                          if (talkId) {
                            const newTalkPath = location.pathname.replace(
                              /\/edit\/[^/?#]+$/,
                              '/new'
                            )
                            history.replace(`${newTalkPath}?type=${isPoster ? 'poster' : 'talk'}`, {
                              eventId: values.eventId || null,
                              sessionId: values.sessionId || null,
                              inheritVenue: values.inheritVenue || false,
                              venueId: values.venueId || null,
                              inheritTime: values.inheritTime || false
                            })
                          }
                        }
                      }
                    }}
                  />
                </Box>
              </ViewHeader>
              <Grid container spacing={3}>
                <Grid
                  container
                  spacing={3}
                  style={{ display: 'flex', alignItems: 'end', padding: '0px 10px' }}>
                  <Grid item xs={12} md={8}>
                    <SingleAutocomplete
                      label="Associated Event or Sub Event"
                      options={combinedEventOptions || []}
                      displayField="title"
                      value={values.sessionId || values.eventId}
                      onChange={(id) =>
                        handleEventChange({ target: { value: id } }, setFieldValue, values)
                      }
                      error={
                        errors.eventId || errors.sessionId ? errors.eventId || errors.sessionId : ''
                      }
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={values.inheritVenue}
                          onChange={(e) => handleInheritVenueChange(e, setFieldValue, values)}
                          name="inheritVenue"
                          color="primary"
                        />
                      }
                      label="Inherit Building from Parent Event?"
                    />

                    <TextField
                      select
                      fullWidth
                      label="Building"
                      variant="outlined"
                      disabled={values.inheritVenue}
                      error={Boolean(touched.venueId && errors.venueId)}
                      value={values.venueId}
                      onChange={(event) =>
                        event.target.value && setFieldValue('venueId', event.target.value)
                      }
                      helperText={touched.venueId && errors.venueId ? errors.venueId : null}>
                      <MenuItem
                        className={classes.stickyMenuItem}
                        onClick={() => setOpenVenueModal(true)}
                        disabled={values.inheritVenue}>
                        <Typography className={classes.buttonItem}>
                          <Add />
                          Create building
                        </Typography>
                      </MenuItem>
                      <Divider />
                      {buildings?.map((building) => (
                        <MenuItem value={building.id} key={building.id}>
                          <Typography>
                            {building?.buildingText?.length > 50
                              ? `${building?.buildingText.substring(0, 50)}...`
                              : building?.buildingText}
                          </Typography>
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>

                <Grid item xs={12} md={12} style={{ marginTop: '10px' }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label={isPoster ? 'Poster Title' : 'Talk Title'}
                    name="title"
                    value={values.title}
                    onChange={(e) => {
                      setFieldValue('title', e.target.value)
                    }}
                    error={touched.title && errors.title}
                    helperText={touched.title && errors.title ? errors.title : ''}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.inheritTime}
                        onChange={(e) => handleInheritTimeChange(e, setFieldValue, values)}
                        name="inheritTime"
                        color="primary"
                      />
                    }
                    label="Inherit Time from Parent Event or Sub Event?"
                  />
                </Grid>
                <Grid item xs={12} md={7}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} lg={6}>
                      <CustomDateTimePicker
                        mode="datetime"
                        value={values.startDate}
                        label="Start Date & Time"
                        name="startDate"
                        is24hrFormat={conference?.is24hrFormat || false}
                        disabled={values.inheritTime}
                        minDateTime={dateTimeInTimezone(
                          values.sessionId ? subEventInfo?.startDate : eventInfo?.startDate,
                          defaultTimezone
                        )}
                        maxDateTime={dateTimeInTimezone(
                          values.sessionId ? subEventInfo?.endDate : eventInfo?.endDate,
                          defaultTimezone
                        )}
                        onChange={(value) => {
                          setFieldValue('startDate', value)
                          if (!talkId) {
                            setFieldValue('endDate', value)
                          }
                        }}
                        error={!!(touched.startDate && errors.startDate)}
                        helperText={touched.startDate && errors.startDate ? errors.startDate : ''}
                        onBlur={() => setFieldTouched('startDate', true)}
                      />
                    </Grid>
                    <Grid item xs={12} lg={6}>
                      <CustomDateTimePicker
                        mode="datetime"
                        value={values.endDate}
                        label="End Date & Time"
                        name="endDate"
                        is24hrFormat={conference?.is24hrFormat || false}
                        disabled={values.inheritTime}
                        minDateTime={dateTimeInTimezone(
                          values.sessionId ? subEventInfo?.startDate : eventInfo?.startDate,
                          defaultTimezone
                        )}
                        maxDateTime={dateTimeInTimezone(
                          values.sessionId ? subEventInfo?.endDate : eventInfo?.endDate,
                          defaultTimezone
                        )}
                        onChange={(value) => setFieldValue('endDate', value)}
                        error={!!(touched.endDate && errors.endDate)}
                        helperText={touched.endDate && errors.endDate ? errors.endDate : ''}
                        onBlur={() => setFieldTouched('endDate', true)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={values.isAbstract ? 3 : 6}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={values.isAbstract}
                        onChange={(e) => {
                          setFieldValue('isAbstract', e.target.checked)
                        }}
                        name="isAbstract"
                        color="primary"
                      />
                    }
                    label={`Add ${isPoster ? 'Poster number' : 'Abstract number'}?`}
                  />
                </Grid>
                {values?.isAbstract && (
                  <Grid item xs={12} md={3}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      label={isPoster ? 'Poster number' : 'Abstract number'}
                      name={isPoster ? 'posterNumber' : 'abstractNumber'}
                      value={isPoster ? values.posterNumber : values.abstractNumber}
                      onChange={(e) => {
                        setFieldValue(isPoster ? 'posterNumber' : 'abstractNumber', e.target.value)
                      }}
                      type="number"
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            {isPoster ? posterPrefix : abstractPrefix}
                          </InputAdornment>
                        )
                      }}
                    />
                  </Grid>
                )}

                <Grid item xs={12} md={6}>
                  <Autocomplete
                    multiple
                    disableCloseOnSelect
                    options={[
                      ...(conference?.tags || []),
                      { name: 'Create new tag', isOption: false }
                    ]}
                    value={values?.tags
                      ?.map((itemId) => conference?.tags?.find((item) => item['id'] === itemId))
                      .filter(Boolean)}
                    error={errors.tags}
                    onChange={(_e, value) => {
                      if (value?.length && value[value?.length - 1].isOption === false) {
                        setTagModalOpen(true)
                        return
                      }
                      setFieldValue(
                        'tags',
                        value?.map((item) => item['id'])
                      )
                    }}
                    getOptionLabel={(option) => option?.name}
                    renderOption={(option) => {
                      return option.isOption === false ? (
                        <li className={classes.nonSelectedMenu}>
                          <Typography className={classes.buttonItem}>
                            <Add />
                            <Typography>{option?.name}</Typography>
                          </Typography>
                        </li>
                      ) : (
                        <Box
                          component="li"
                          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                          <Chip
                            label={option.name}
                            size="small"
                            style={{
                              backgroundColor: option?.color || '#f1f1f1',
                              color: getContrastColor(option?.color) || '#333',
                              borderRadius: '10px',
                              fontSize: '14px',
                              fontWeight: '500',
                              padding: '2px 4px',
                              height: '24px'
                            }}
                          />
                        </Box>
                      )
                    }}
                    renderTags={(tagValue, getTagProps) =>
                      tagValue.map((option, index) => (
                        <Chip
                          key={option?.id}
                          label={option?.name}
                          size="small"
                          style={{
                            backgroundColor: option?.color || '#f1f1f1',
                            color: getContrastColor(option?.color) || '#333',
                            marginRight: '4px',
                            fontSize: '14px',
                            borderRadius: '10px',
                            fontWeight: '500',
                            padding: '2px 4px',
                            height: '24px'
                          }}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={touched.tags && errors.tags}
                        variant="outlined"
                        label="Tags"
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <MultiAutocomplete
                    label="Moderators"
                    options={confModerators || []}
                    displayField="fullName"
                    value={values.moderators}
                    error={errors.moderators}
                    warningText={rolesOverlapWarning}
                    onChange={(value) => setFieldValue('moderators', value)}
                    createNewOption={true}
                    createNewLabel="Create Moderator"
                    onCreateNew={() =>
                      setSpeakerModalInfo({
                        open: true,
                        role: SpeakerRoles.MODERATOR
                      })
                    }
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <MultiAutocomplete
                    label="Speakers"
                    options={confSpeakers || []}
                    displayField="fullName"
                    value={values.speakers}
                    error={errors.speakers}
                    warningText={rolesOverlapWarning}
                    onChange={(value) => setFieldValue('speakers', value)}
                    createNewOption={true}
                    createNewLabel="Create Speaker"
                    onCreateNew={() =>
                      setSpeakerModalInfo({
                        open: true,
                        role: SpeakerRoles.PRESENTER
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <MultiAutocomplete
                    label="Sponsors"
                    options={confSponsors}
                    displayField="organization"
                    value={values.sponsors}
                    error={errors.sponsors}
                    onChange={(value) => setFieldValue('sponsors', value)}
                    createNewOption={true}
                    createNewLabel="Create Sponsor"
                    onCreateNew={() => setOpenSponsorModal(true)}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Box style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                    <Box
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                      <label htmlFor="synopsis" className={classes.label}>
                        Synopsis
                      </label>
                      <Box style={{ display: 'flex', gap: 8 }}>
                        {values.synopsis?.replace(/<[^>]*>/g, '').trim() && (
                          <Button
                            type="button"
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={
                              summarizing || reverting ? (
                                <CircularProgress size={14} color="inherit" />
                              ) : (
                                <AutoAwesomeOutlinedIcon />
                              )
                            }
                            disabled={summarizing || reverting}
                            onClick={() => {
                              if (values.originalSynopsis) {
                                setConfirmResummarize(true)
                              } else {
                                handleSummarizeSynopsis(values, setFieldValue)
                              }
                            }}>
                            {reverting
                              ? 'Reverting...'
                              : summarizing
                              ? 'Summarizing...'
                              : values.originalSynopsis
                              ? 'Re-summarize'
                              : 'Summarize with AI'}
                          </Button>
                        )}
                      </Box>
                    </Box>
                    <TipTapEditor
                      id="synopsis"
                      hasPlaceholders={false}
                      value={values.synopsis}
                      onChange={(value) => setFieldValue('synopsis', value)}
                      placeholder="Write synposis here..."
                    />
                    {values.originalSynopsis && (
                      <Box style={{ display: 'flex', gap: 16, marginTop: 4 }}>
                        <Link
                          component="button"
                          type="button"
                          variant="body2"
                          className={classes.linkButton}
                          disabled={summarizing || reverting}
                          onClick={() => setViewingOriginalSynopsis((prev) => !prev)}>
                          <VisibilityOutlinedIcon fontSize="inherit" className={classes.linkIcon} />
                          {viewingOriginalSynopsis ? 'Hide Original' : 'View Original'}
                        </Link>
                        <Link
                          component="button"
                          type="button"
                          variant="body2"
                          className={classes.linkButton}
                          disabled={summarizing || reverting}
                          onClick={() => handleRevertSynopsisToOriginal(values, setFieldValue)}>
                          {reverting ? (
                            <CircularProgress size={12} color="inherit" />
                          ) : (
                            <RestartAltOutlinedIcon fontSize="inherit" className={classes.linkIcon} />
                          )}
                          {reverting ? 'Reverting...' : 'Undo AI'}
                        </Link>
                      </Box>
                    )}
                    {viewingOriginalSynopsis && (
                      <Box className={classes.originalTextBox}>
                        <Box className={classes.originalTextLabel}>ORIGINAL — READ ONLY</Box>
                        <Box
                          className={classes.originalTextContent}
                          dangerouslySetInnerHTML={{ __html: values.originalSynopsis }}
                        />
                      </Box>
                    )}
                    <ConfirmModal
                      dialogTitle="Summarize Synopsis"
                      dialogText="This synopsis has already been summarized. Do you want to summarize it again?"
                      open={confirmResummarize}
                      closeModal={() => setConfirmResummarize(false)}
                      handleConfirm={() => handleSummarizeSynopsis(values, setFieldValue)}
                    />
                  </Box>
                </Grid>

                {conference?.havePolls && (
                  <>
                    <Grid item xs={12} md={12}>
                      <Box className={classes.radioGroup}>
                        <Typography className={classes.radioLabel}>
                          Do you want to associate a poll with this talk?
                        </Typography>
                        <RadioGroup
                          row
                          value={values.havePolls}
                          onChange={(e) => {
                            // Don't eagerly clear pollIds here: PollAssignment only renders
                            // while havePolls is 'yes', so toggling to 'no' unmounts it and
                            // toggling back remounts it fresh — clearing pollIds first would
                            // make it think this entity never had any polls, disabling every
                            // still-genuinely-assigned poll as "assigned elsewhere" before the
                            // admin even saves. onSubmit already coerces pollIds to [] when
                            // havePolls is 'no', so nothing here needs to force it early.
                            setFieldValue('havePolls', e.target.value)
                            if (e.target.value === 'no' && speakerError) {
                              setSpeakerError('')
                            }
                          }}>
                          <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Typography variant="body2">Yes</Typography>}
                            value="yes"
                          />
                          <FormControlLabel
                            control={<Radio size="small" />}
                            label={<Typography variant="body2">No</Typography>}
                            value="no"
                          />
                        </RadioGroup>
                      </Box>
                    </Grid>
                    {values.havePolls === 'yes' && (
                      <Grid item xs={12}>
                        <PollAssignment
                          conferenceId={user?.conferenceId}
                          speakerIds={values.speakers}
                          confSpeakers={confSpeakers}
                          value={values.pollIds}
                          persistedPollIds={talk?.pollIds ?? (talk?.pollId ? [talk.pollId] : [])}
                          onChange={(pollIds) => setFieldValue('pollIds', pollIds)}
                          onSpeakerAdded={(speakerId) =>
                            setFieldValue('speakers', [...values.speakers, speakerId])
                          }
                          error={touched.pollIds && errors.pollIds}
                        />
                      </Grid>
                    )}
                  </>
                )}
              </Grid>

              {/* Document Attachments */}
              <Grid item xs={12} style={{ marginTop: '20px' }}>
                <DocumentUpload
                  title={isPoster ? 'Poster Documents' : 'Talk Documents'}
                  subTitle={`Attach documents related to this ${
                    isPoster ? 'poster' : 'talk'
                  }. Allowed formats: PDF, DOCX, XLSX, PPTX, TXT (Max size: 10MB)`}
                  attachmentType="talks"
                  conferenceId={user?.conferenceId}
                  entityId={talkId}
                  attachments={attachments}
                  onAttachmentAdded={handleAttachmentAdded}
                  onAttachmentDeleted={handleAttachmentDeleted}
                  onTemporaryAttachments={handleTemporaryAttachments}
                  resetKey={attachmentsResetKey}
                  onPendingUploadsChange={setHasPendingUploads}
                />
              </Grid>

              <Grid container spacing={2} className={classes.actionButtons}>
                <Grid item>
                  <Button
                    disabled={saveProgress || createNewProgress}
                    size="large"
                    onClick={goBack}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item>
                  <ProgressButton
                    type="button"
                    label="Save"
                    inProgress={saveProgress}
                    disabled={saveProgress || createNewProgress}
                    onClick={async () => {
                      let proceed = false
                      if (hasPendingUploads) {
                        try {
                          await confirm({
                            title: 'Pending File Uploads',
                            description:
                              "You have selected files that haven’t been uploaded. If you save now without clicking 'Upload All,' these files will not be uploaded. Do you want to continue?"
                          })
                          proceed = true
                        } catch {
                          proceed = false
                          // do nothing
                        }
                      } else {
                        proceed = true
                      }
                      if (proceed || !hasPendingUploads) {
                        setSaveProgress(true)
                        await validateForm()
                        const submitStatus = await submitForm()
                        setSaveProgress(false)
                        if (isValid && submitStatus) {
                          goBack()
                        }
                      }
                    }}
                  />
                </Grid>
                <Grid item>
                  <ProgressButton
                    type="button"
                    label="Save and Create New"
                    inProgress={createNewProgress}
                    disabled={createNewProgress || saveProgress}
                    onClick={async () => {
                      let proceed = false
                      if (hasPendingUploads) {
                        try {
                          await confirm({
                            title: 'Pending File Uploads',
                            description:
                              "You have selected files that haven’t been uploaded. If you save now without clicking 'Upload All,' these files will not be uploaded. Do you want to continue?"
                          })
                          proceed = true
                        } catch {
                          proceed = false
                          // do nothing
                        }
                      } else {
                        proceed = true
                      }
                      if (proceed || !hasPendingUploads) {
                        setCreateNewProgress(true)
                        await validateForm()
                        const submitStatus = await submitForm()
                        setCreateNewProgress(false)
                        setSaveProgress(false)
                        if (submitStatus && isValid) {
                          setAttachments([])
                          setTemporaryAttachments([]) // Clear temporary attachments
                          setAttachmentsResetKey((prev) => prev + 1) // Increment reset key to trigger DocumentUpload reset
                          dispatch(resetTalkStore())

                          const isAbstractTalk = localStorage.getItem('lastAbstractNumberSelected')
                          const keyToCheck = isPoster ? 'posterNumber' : 'abstractNumber'
                          let nextNumber = 1
                          if (isAbstractTalk === 'true') {
                            const lastNumber = await dispatch(getLastNumber(keyToCheck))
                            nextNumber = lastNumber + 1
                          }

                          // Reset form to clear all validation errors and touched states
                          resetForm({
                            values: {
                              ...initialValues,
                              eventId: values.eventId || '',
                              sessionId: values.sessionId || '',
                              venueId: values.venueId || '',
                              inheritVenue: values.inheritVenue || false,
                              inheritTime: values.inheritTime || false,
                              startDate: moment(parseInt(localStorage.getItem('talkStartDate'))).tz(
                                conference ? conference?.timezone : defaultTimezone
                              ),
                              endDate: moment(parseInt(localStorage.getItem('talkEndDate'))).tz(
                                conference ? conference?.timezone : defaultTimezone
                              ),
                              isAbstract: isAbstractTalk === 'true',
                              [keyToCheck]: isAbstractTalk === 'true' ? nextNumber : 1,
                              title: '',
                              speakers: [],
                              moderators: [],
                              sponsors: [],
                              tags: [],
                              synopsis: '',
                              originalSynopsis: '',
                              havePolls: 'no',
                              pollIds: []
                            }
                          })
                          if (talkId) {
                            const newTalkPath = location.pathname.replace(
                              /\/edit\/[^/?#]+$/,
                              '/new'
                            )
                            history.replace(`${newTalkPath}?type=${isPoster ? 'poster' : 'talk'}`, {
                              eventId: values.eventId || null,
                              sessionId: values.sessionId || null,
                              inheritVenue: values.inheritVenue || false,
                              venueId: values.venueId || null,
                              inheritTime: values.inheritTime || false
                            })
                          }
                        }
                      }
                    }}
                  />
                </Grid>
              </Grid>
              <CustomPopup
                title="Create building"
                maxWidth="lg"
                open={openVenueModal}
                onClose={() => setOpenVenueModal(false)}>
                <BuildingForm
                  displayContext="modal"
                  onCloseModal={() => setOpenVenueModal(false)}
                  onSuccess={(venueId) => {
                    setOpenVenueModal(false)
                    setFieldValue('venueId', venueId)
                  }}
                />
              </CustomPopup>
              <CustomPopup
                title="Create Tag"
                maxWidth="md"
                open={tagModalOpen}
                onClose={() => setTagModalOpen(false)}>
                <TagForm
                  onCancel={() => setTagModalOpen(false)}
                  conference={conference}
                  onSuccess={(tagId) => {
                    setTagModalOpen(false)
                    setFieldValue('tags', [...values?.tags, tagId])
                  }}
                />
              </CustomPopup>
              <CustomPopup
                title="Create sponsor"
                maxWidth="lg"
                open={openSponsorModal}
                onClose={() => setOpenSponsorModal(false)}>
                <OrganizationForm
                  displayContext="modal"
                  onCloseModal={() => setOpenSponsorModal(false)}
                  onSuccess={async (sponsorId) => {
                    await fetchSponsors()
                    setOpenSponsorModal(false)
                    setFieldValue(
                      'sponsors',
                      values?.sponsors?.length > 0 ? [...values.sponsors, sponsorId] : [sponsorId]
                    )
                  }}
                />
              </CustomPopup>
              <CustomPopup
                title={`Create ${
                  speakerModalInfo?.role === SpeakerRoles.PRESENTER ? 'Speaker' : 'Moderator'
                }`}
                maxWidth="lg"
                open={speakerModalInfo?.open || false}
                onClose={() => setSpeakerModalInfo(null)}>
                <SpeakerForm
                  displayContext="modal"
                  preDefinedRole={speakerModalInfo?.role}
                  onCloseModal={() => setSpeakerModalInfo(null)}
                  onSuccess={async (id) => {
                    await fetchModeratorsAndPresenters()
                    setSpeakerModalInfo(null)
                    if (speakerModalInfo?.role === SpeakerRoles.PRESENTER) {
                      setFieldValue('speakers', [...values.speakers, id])
                    } else {
                      setFieldValue('moderators', [...values.moderators, id])
                    }
                  }}
                />
              </CustomPopup>
            </Form>
            )
          }}
        </Formik>
      </CustomBox>
    </Box>
  )
}
export default TalkForm

const useStyles = makeStyles({
  label: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    color: '#606060'
  },
  linkButton: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
    fontSize: '13px',
    textTransform: 'none',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
    '&:hover': {
      textDecoration: 'underline',
      background: 'none'
    },
    '&:disabled': {
      cursor: 'default',
      opacity: 0.5
    }
  },
  linkIcon: {
    fontSize: '15px'
  },
  originalTextBox: {
    marginTop: '0.5rem',
    padding: '12px',
    borderRadius: '4px',
    border: '1px solid #e0e0e0',
    backgroundColor: '#fafafa'
  },
  originalTextLabel: {
    fontSize: '11px',
    letterSpacing: '0.5px',
    color: '#9e9e9e',
    marginBottom: '6px'
  },
  originalTextContent: {
    fontSize: '14px',
    color: '#606060'
  },
  chipLabel: {
    fontSize: '13px',
    letterSpacing: '0.5px',
    fontWeight: 'bold'
  },
  chip: {
    background: '#c62828',
    color: '#FFFFFF'
  },
  listItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  radioGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  },
  radioLabel: {
    fontWeight: 600,
    fontSize: '16px',
    color: '#2f2f2f'
  },
  error: {
    marginTop: '5px',
    marginLeft: '15px',
    color: '#ec2625'
  },
  actionButtons: {
    marginTop: '16px',
    display: 'flex',
    justifyContent: 'end'
  },
  iconBtn: {
    padding: '0px'
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  },
  buttonItem: {
    color: colors.indigo,
    fontWeight: 600,
    display: 'flex',
    alignItems: 'center',
    gap: '0.3rem'
  },
  stickyMenuItem: {
    position: 'sticky',
    top: 0,
    zIndex: 1,
    backgroundColor: '#fff'
  },
  nonSelectedMenu: {
    backgroundColor: 'transparent !important'
  }
})
